export const ADD_ALERT = "ADD_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const CLEAR_ALL_ALERTS = "CLEAR_ALL_ALERTS";
